import React, { useState, useEffect, useCallback, useMemo } from "react";
import GameImage from "./GameImage.jsx";


export default function GameItem(props) {
    const {
        session,
        game,
        categories,
        brands,
        isDesktop,
        showJackpot,
        goLazyImage,
        restApiUrl,
        apiKey,
        icon,
        textColor,
    } = props;

    const [favoritIcon, setFavoritIcon] = useState('ico-star-outline');
    const [loggedIn, setLoggedIn] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const isFavorite = loggedIn && session.player.favorites.includes(game.id);

    useEffect(() => {
        const onNetworkError = (error) => {
            console.error('Network Error:', error);
        };

        casinoModule.repos.base.networkErrorsListener = onNetworkError;

        return () => {
            casinoModule.repos.base.networkErrorsListener = null;
        };
    }, []);

    useEffect(() => {
        setLoggedIn(!!session.player);
    }, [session?.player]);

    // Toggle favorite game
    const toggleFavoritGame = useCallback(() => {
        if (!loggedIn) return;

        setFavoritIcon((prevIcon) => (prevIcon === 'ico-star-outline' ? 'ico-star-fill' : 'ico-star-outline'));

        const indexOfGameId = session.player.favorites.indexOf(game.id);
        if (indexOfGameId === -1) {
            session.player.favorites.push(game.id);
            casinoModule.repos.favoritesRepo(restApiUrl, apiKey).create(game);
        } else {
            session.player.favorites.splice(indexOfGameId, 1);
            casinoModule.repos.favoritesRepo(restApiUrl, apiKey).remove(game);
        }
    }, [loggedIn, session.player, game, restApiUrl, apiKey]);

    const createGoogleTagEvent = useCallback(() => {
        if (!categories) return;

        const categoriesArray = Object.keys(game.kt)
            .map((key) => categories.find((x) => x.id === key)?.name)
            .filter(Boolean);

        casinoModule.utils.createGoogleTagManagerEvent({
            event: 'game_click',
            game_name: game.n,
            game_provider: brands[game.bID]?.name,
            game_type: categoriesArray.join(),
            jackpot: game.jp ? 'yes' : 'no',
            jackpot_amount: game.jp || 0,
            gameId: game.id,
        });
    }, [categories, game, brands]);

    const startGame = useCallback((sifraIgre, demo) => {
        window.parent.postMessage(
            {
                type: "play-game",
                params: { sifra: sifraIgre, demo: demo },
            },
            '*'
        );

        createGoogleTagEvent();
    }, [createGoogleTagEvent]);

    const openMobileDialog = useCallback((sifraIgre, demo) => {
        window.parent.postMessage(
            {
                type: "dialog",
                params: { sifra: sifraIgre, demo: demo },
            },
            '*'
        );
    }, []);

    const renderFavoritStar = useCallback(() => {
        const starClass = isFavorite ? 'ico-star-fill' : 'ico-star-outline';

        return (
            <>
                <button
                    className={`star ${starClass}`}
                    onMouseEnter={() => setShowPopup(true)}
                    onMouseLeave={() => setShowPopup(false)}
                    onClick={(e) => {
                        e.preventDefault();
                        if (restApiUrl && apiKey) toggleFavoritGame();
                    }}
                />
                {!loggedIn && showPopup && (
                    <div className="popup">
                        <p className="popup-text">Za prijavljene korisnike.</p>
                    </div>
                )}
            </>
        );
    }, [isFavorite, loggedIn, showPopup, restApiUrl, apiKey, toggleFavoritGame]);

    const gameItemContent = useMemo(() => (
        <>
            <div className="game-img-holder">
                <GameImage
                    game={game}
                    brands={brands}
                    goLazyImage={goLazyImage}
                    isDesktop={isDesktop}
                    startGame={startGame}
                    icon={icon}
                    loggedIn={loggedIn}
                />

                {game.p?.includes("o") && (
                    <div className="maintenance-overlay">
                        <div className="icon" />
                        <p className="info">Održavanje u tijeku</p>
                    </div>
                )}
            </div>

            <div className="game-info">
                {isDesktop && !icon && renderFavoritStar()}
                <p className="game-name" style={{ color: textColor || "#5E6467" }}>
                    {game.n}
                </p>
            </div>

            {showJackpot && game.jp && (
                <div className={`jackpot-badge${!isDesktop && icon ? " mobile" : ""}`} />
            )}

            {/* Promocije */}
            {game.p?.includes("cc") && <div className="clover-chance" />}
            {game.p?.includes("daw") && <div className="drops-and-wins" />}
            {game.p?.includes("ex") && <div className="exclusive" />}
            {game.p?.includes("n") && game.p?.includes("ex") && <div className="nova" />}
        </>
    ));

    return (
        <div
            className={"game-item" +
                (isDesktop ? " hover" : "") +
                (game?.p?.includes("o") ? " maintenance" : "") +
                (icon ? " icon" : "") +
                (showJackpot && game.jp ? " jackpot" : "")
            }
            onClick={() => !isDesktop && openMobileDialog(game?.s, true)}
        >
            {game && gameItemContent}
        </div>
    );
};

